import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from '@/components/Logo';

export default function ApprovalPending() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-dark-lighter to-dark p-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 text-center"
      >
        <div className="mb-8">
          <Logo className="mx-auto h-12" />
        </div>

        <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-4">
          Thank you for joining our early access!
        </h1>

        <p className="text-gray-600 mb-8">
          Your account request has been received and is now under review. We'll send you an email as soon as your account is approved. We're thrilled to have you on board and truly appreciate your interest in helping us shape the future of InsighTalks.
        </p>

        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-primary text-dark rounded-lg hover:bg-primary-hover transition-colors"
        >
          Return to Home
        </button>
      </motion.div>
    </div>
  );
}